const isAbsoluteWidth = (w) => w.unit === "px";

export { isAbsoluteWidth };
